import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UIIcon from 'UIComponents/icon/UIIcon';
import styled, { theme } from '../../utils/Styling';
import { rgba } from 'UIComponents/core/Color';

const RoundelIconImpl = (_ref) => {
  let {
    color = theme.colors.OLAF,
    className,
    iconSize = 10,
    component: Component = 'span',
    componentProps
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["color", "className", "iconSize", "component", "componentProps"]);

  return /*#__PURE__*/_jsx(Component, Object.assign({
    className: className
  }, componentProps, {
    children: /*#__PURE__*/_jsx(UIIcon, Object.assign({
      color: color,
      size: iconSize
    }, props, {
      className: "m-left-0 m-right-0"
    }))
  }));
};

export const RoundelIcon = styled(RoundelIconImpl).withConfig({
  displayName: "RoundelIcon",
  componentId: "sc-13w9k36-0"
})(["width:", "px;height:", "px;background-color:", ";", ";display:flex;justify-content:center;align-items:center;flex-direction:row;padding-top:2px;border-radius:50%;"], props => props.width || 20, props => props.height || 20, props => rgba(props.backgroundColor || theme.colors.OLAF, props.opacity || 1), props => props.borderColor && `border: 2px solid
      ${rgba(props.borderColor, props.opacity || 1)}`);